import { t } from '../../../../../../modules/infra/i18n';

// eslint-disable-next-line import/prefer-default-export
export const getNoDataMessage = (hasVendors, hasProductsWithVendors) => {
  if (!hasVendors) {
    return t('products:purchase_order.no_vendors_message');
  }

  if (!hasProductsWithVendors) {
    return t('products:purchase_order.no_products_with_vendors_message');
  }

  return t('products:purchase_order.no_products_for_vendor_message');
};
